export default function NamaKendoWindowTemplate(data) {
    //language=HTML
    return `
        <div id="window${data.elementId}" class="windowSelect window-select d-flex flex-column justify-content-between p-0">
            <div id="grid" class="px-2 n-text-right"></div>

            <div class="searcherWindowBtns n-text-left p-2">
                <button class=" k-button rounded-sm" id="selectAll">${data.translateId("selectAll")}</button>
                <button class=" k-button rounded-sm" id="deleteAll">${data.translateId("deleteAll")}</button>
                <button class=" k-button rounded-sm" id="deleteSelected">${data.translateId("deleteSelected")}</button>
                <button class=" k-button rounded-sm" id="cancel">${data.translateId("cancel")}</button>
                <button class=" k-button rounded-sm" id="ok">${data.translateId("ok")}</button>
            </div>
        </div>`;
}